import type { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { ChangeList, ChangeListRow } from '../../../design-system';

/** 발령안 작성과 검토에서 같은 대상·변경 목록을 사용합니다. 편집과 값 해석은 호출자가 소유합니다. */
export function StaffingPlanChangeList({ label, children }: { label: string; children: ReactNode }) {
  return <ChangeList label={label}>{children}</ChangeList>;
}

export function StaffingPlanChangeRow({ label, identity, action, children }: { label: string; identity: ReactNode; action?: ReactNode; children: ReactNode }) {
  return <ChangeListRow ariaLabel={`${label} 변경 사항`} identity={identity} action={action}>{children}</ChangeListRow>;
}

export function StaffingPlanChangeIdentity({ name, avatar, job, organization, badge, selection }: { name: string; avatar: ReactNode; job?: string; organization?: string; badge?: ReactNode; selection?: ReactNode }) {
  return <Stack direction="row" spacing={1.5} sx={{ minWidth: 0, alignItems: 'center' }}>
    {selection}
    {avatar}
    <Stack spacing={badge ? 0.5 : 0} sx={{ minWidth: 0, alignItems: 'flex-start', overflowWrap: 'anywhere' }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>{name}</Typography>
      {job && <Typography variant="caption" color="text.secondary">{job}</Typography>}
      {organization && <Typography variant="caption" color="text.secondary">{organization}</Typography>}
      {badge}
    </Stack>
  </Stack>;
}
